// extracted by mini-css-extract-plugin
module.exports = {"tabContent":"reports_tabContent_13kY7"};